import * as _ from 'lodash-es';
import {cloneDeep} from 'lodash-es';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {MatLegacySelectChange as MatSelectChange} from '@angular/material/legacy-select';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '@app/services/auth/auth.service';
import {environment} from '@environments/environment';
import {fuseAnimations} from '@fuse/animations';
import {FuseMatSidenavHelperService} from '@fuse/directives/fuse-mat-sidenav/fuse-mat-sidenav.service';
import {UserContext} from '@models/user';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {AppState} from '@store/app.states';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {DxDataGridComponent} from 'devextreme-angular';
import DevExpress from '@devextreme';
import Column = DevExpress.ui.dxDataGrid.Column;
import {debounceTime, distinctUntilChanged, take, withLatestFrom} from 'rxjs/operators';
import {JsonPipe, DatePipe} from '@angular/common';

import {
  clearUserListStore,
  ConnectAs,
  DisplayExtSelector as displayExtAction,
  DisplayUserDetail, MoveToCommunities, OpenCreateUserDialog,
  RefreshList,
  SetSideNavStatus, UpdateBatchExt,
} from './store/users-list.actions';
import {UxInteractions} from './store/users-list.reducers';
import {
  currentUxInteraction,
  getCurrentUsersList,
  getUrlsInfo
} from './store/users-list.selector';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {UsersListService} from '@app/4dm1n/users-list/users-list.service';
import {FuseSidebarService} from '../../../@fuse/components/sidebar/sidebar.service';
import {CommonServicesService} from '@app/services/common-services.service';
import {confirm} from 'devextreme/ui/dialog';
import {ICommunity} from '../../../@shared/inbe-communities-selector/communities.service';
import {AngularFirestoreCollection} from '@angular/fire/compat/firestore';
import {Observable} from 'rxjs';
import {RefreshList as refreshExtList} from '@app/components/projects/ext-profils/store/ext-profils.actions';
import {ExportingEvent} from "devextreme/ui/data_grid";
import {Workbook} from "exceljs";
import {saveAs} from "file-saver";

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsersListComponent extends OnDestroyMixin implements OnInit, OnDestroy {

  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  userContext: UserContext = this.authService.getContext();
  uxInteractions$: Observable<UxInteractions> = this.store.select(currentUxInteraction).pipe(untilComponentDestroyed(this));

  //
  // Liste des utilisateurs :
  //
  usersList: IUserInbe[] | any = null;
  currentUserType = 'contributor';
  selectedUsersId = [];
  selectedUsersEmails: string[] = [];
  //
  // Gestion de la mise à jour des exts
  //

  selectedExtProfils = [];
  fEditExt = new UntypedFormGroup({});

  newExtProfils = [];
  newExtProfilsIndex = [];
  fNEditExt = new UntypedFormGroup({});

  toDeleteExtProfils = [];

  allExtProfils = [];
  possibleValues: { [key: string]: string[] } = {};
  displayHints = {};

  editExtModified: { [key: string]: string } = {};
  editExtModifiedIndex: string[] = [];

  createLegacyEmailGroupCommunitiesIds: string[] = [];
  createLegacyEmailGroup = new UntypedFormGroup({
    create: new UntypedFormControl(false),
    groupCaption: new UntypedFormControl(this.datePipe.transform(new Date(), 'yyyyMMdd'), [Validators.required]),
    communityId: new UntypedFormControl(),
  });

  //
  // Gestion des moveToCommunities
  //
  moveToCommunitiesIds = [];

  //
  // Panneaux
  //
  baseUrl = environment.legacyBaseUrl;
  secretToken = '';
  selectedPublication: { selectedItem: { title: string, uuid: string } } = null;
  modeTestSelected = new UntypedFormControl(false);

  avatarUrlExt = environment.bearAvataUrlExtenssion;

  batchUserSelectedId = new UntypedFormControl('');
  idSelected: number[] = [];
  batchUserSelectedEmails = new UntypedFormControl('');
  emailSelected: string[] = [];
  communitiesToRefresh: string[] = [];

  // Divers / UI
  displayExtNotEmptyGroup: UntypedFormGroup = null;
  contributorsOrClient = new UntypedFormControl();
  nbVisibleRow = 0;
  nbLastMonth = '6';
  filterValue = [];
  tableColumns: Column[] = [];
  displayUserCreateComponent = false;

  private itemsCollection: AngularFirestoreCollection<any>;

  items: Observable<any>;

  title: string = 'Users List';

  constructor(
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    public translate: TranslateService,
    public router: Router,
    private authService: AuthService,
    private commonServices: CommonServicesService,
    private usersListService: UsersListService,
    private _fuseSidebarService: FuseSidebarService,
    private jsonPipe: JsonPipe,
    private datePipe: DatePipe,
    private activeRoute: ActivatedRoute,
  ) {
    super();
    this._fuseSidebarService.getSidebar('navbar')?.fold();
    this.title = this.router.url.includes('contributor') ? 'Panélistes' : 'Clients';

  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.store.dispatch(clearUserListStore());
  }

  ngOnInit() {

    this.store.dispatch(new refreshExtList({forceRefresh: true}));

    this.currentUserType = this.activeRoute.snapshot.params?.userType || 'contributor';

    this.store.select(getCurrentUsersList).pipe(untilComponentDestroyed(this)).subscribe((data) => {
      // if (this.currentUserType === 'client') {
      this.usersList = data as IUserInbe[];
      this.collectUsersInfo();
      this.cdr.markForCheck();
      // }
    });


    //
    // console.log(this.currentUserType);
    //

    this.uxInteractions$.pipe(distinctUntilChanged(), untilComponentDestroyed(this)).subscribe((data) => {

      const newFilterValue = [];

      if (data.listMode.userType !== 'all') {
        newFilterValue.push(['type', '=', data.listMode.userType]);
      }
      this.currentUserType = data.listMode.userType;

      this.filterValue = newFilterValue;

      if (this.idSelected.length > 0 || this.emailSelected.length > 0) {
        this.filterValue = null;
      }

    });

    this.displayExtNotEmptyGroup = new UntypedFormGroup({
      selected: new UntypedFormControl(''),
    });

    this.displayExtNotEmptyGroup.statusChanges.pipe().subscribe((datas) => {

      const selectExt: string[] = this.displayExtNotEmptyGroup.value.selected as string[] || [];
      const buildedConditions = [];
      selectExt.forEach((aExt) => {
        buildedConditions.push([aExt, '<>', null]);
        buildedConditions.push('AND');
      });
      // this.filterValue = [...this.filterValue, [buildedConditions]];
      this.filterValue = buildedConditions;

    });

    this.refreshColumns();
    this.changeSwType({value: ['client']});

    this.store.select(getCurrentUsersList)
      .pipe(take(1))
      .pipe(untilComponentDestroyed(this))
      .subscribe(data => {
        if (data.length === 0) {
          this.refresh();
        }
      });

    this.store.select(getUrlsInfo)
      .pipe(untilComponentDestroyed(this))
      .subscribe(data => {
        this.secretToken = data.secretToken;
      });

    this.batchUserSelectedId.valueChanges.subscribe(() => {

      this.idSelected =
        this.batchUserSelectedId.value
          .trim()
          .split(' ')
          .join(',')
          .split(/\r?\n/)
          .join(',')
          .split(';')
          .join(',')
          .split(',')
          .map((el) => el.replace(/'/g, '').replace(' ', ''))
          .filter((el) => {
            if (el.length > 0) {
              return el;
            }
          }) || [];

    });
    this.batchUserSelectedEmails.valueChanges.subscribe(() => {

      this.emailSelected =
        this.batchUserSelectedEmails.value
          .trim()
          .split(' ')
          .join(',')
          .split(/\r?\n/)
          .join(',')
          .split(';')
          .join(',')
          .split(',')
          .map((el) => el.replace(/'/g, '').replace(' ', ''))
          .filter((el) => {
            if (el.length > 0) {
              return el;
            }
          }) || [];


    });

    this.createLegacyEmailGroup.valueChanges.pipe(
      debounceTime(1500),
      untilComponentDestroyed(this),
    ).subscribe(() => {
      const label = this.createLegacyEmailGroup.get(['groupCaption']).value;
      this.createLegacyEmailGroup.get(['groupCaption']).patchValue(this.commonServices.getSlug(label), {emitEvent: false});
    });

  }

  updateRowsCount(): void {
    if (this.dataGrid?.instance) {
      this.nbVisibleRow = this.dataGrid.instance.totalCount();
    }
  }

  refreshColumns(userType = 'contributor') {

    const baseColumns: Column[] = [
      {caption: 'Actions', cellTemplate: 'actionTemplate', width: 195, minWidth: 195, fixed: true, allowExporting: false},

      {dataField: 'type', caption: 'Type', visible: false},
      {dataField: 'media', caption: 'Media', allowResizing: false, cellTemplate: 'mediaTemplate', width: 70, minWidth: 70, allowExporting: false},
      {dataField: 'userId', caption: 'userId', width: 115, visible: true},
      {dataField: 'organization', caption: 'Organization', width: 230, visible: true},
      {dataField: 'email', caption: 'Email', visible: true},
      {dataField: 'fullname', caption: 'Fullname', width: 250, visible: true},
      {dataField: 'lastLogged', caption: 'Last logged', dataType: 'date', visible: true, width: 115},

    ];

    let extraColumns: Column[] = [];
    if (this.selectedExtProfils.length > 0) {

      extraColumns = [
        {
          caption: 'ExtProfils', isBand: true,
          columns: [
            ...this.selectedExtProfils.map((extName) => ({dataField: extName, caption: extName, visible: true})),
          ]
        },
        {dataField: 'created', caption: 'Created', dataType: 'date', visible: false, width: 115},
      ];

      this.changeSwType({value: ['contributor']});

    } else {

      extraColumns = [
        // {dataField: 'fullname', caption: 'Fullname', visible: false},
        // {dataField: 'lastLogged', caption: 'Last logged', dataType: 'date', visible: true, width: 115},
      ];

      if (userType === 'client') {
        extraColumns = [
          ...extraColumns,
          {dataField: 'organization', caption: 'Organization', visible: true},
          {dataField: 'clientSwitched', caption: 'clientSwitched', dataType: 'boolean', visible: false},
          {dataField: 'isSaas', caption: 'isSaas', dataType: 'boolean', visible: true},
          {dataField: 'saasOrganization', caption: 'Saas Organization', visible: true},
          {dataField: 'created', caption: 'Created', dataType: 'date', visible: false, width: 115},
        ];
      }

      if (userType === 'contributor') {
        extraColumns = [
          ...extraColumns,
          {dataField: 'firstname', caption: 'Firstname', visible: false},
          {dataField: 'lastname', caption: 'Lastname', visible: false},
          {dataField: 'facebookUrl', caption: 'Facebook Url', visible: false},
          {dataField: 'created', caption: 'Created', dataType: 'date', visible: false, width: 115},
        ];
      }

    }

    if (this.selectedPublication) {
      extraColumns.push({
        caption: 'Login URL', visible: true, calculateCellValue: rowData => {
          return this.generateLoginAsUrl(rowData.jwtToken);
        }
      });
    }

    const idSelFilterExp = [];
    if (this.idSelected.length > 0) {
      this.idSelected.forEach((anId) => {
        idSelFilterExp.push(
          [
            'userId', '=', anId
          ], 'or'
        );
      });
    }
    if (this.emailSelected.length > 0) {
      this.emailSelected.forEach((anEmail) => {
        idSelFilterExp.push(
          [
            'email', '=', anEmail
          ], 'or'
        );
      });
    }

    this.filterValue = [idSelFilterExp];
    this.tableColumns = [...baseColumns, ...extraColumns];

  }

  changeSwType(e): void {
    const newFilterValue = [];

    e.value.map((value, index) => {
      newFilterValue.push(['type', '=', value]);
      if (index <= e.value.length) {
        newFilterValue.push('or');
      }
    });
    this.filterValue = newFilterValue;

  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
        location: 'after',
        template: 'toolbarTemplate'
      }
    );
  }

  refresh(): void {

    this.store.dispatch(
      RefreshList(
        {
          nbMonths: parseInt(this.nbLastMonth, 0),
          extProfils: [...this.selectedExtProfils],
          emails: this.emailSelected,
          userIds: this.idSelected,
          communitiesIds: this.communitiesToRefresh,
        }
      ));
    this.refreshColumns();

  }

  // Sous sélection de communautés
  communitiesToRefreshChanged(e) {

    this.communitiesToRefresh = e.communitiesIds;

    //
    // On met à jour l'éventuelle legacy email..
    //
    this.createLegacyEmailGroupCommunitiesIds = cloneDeep(e.communitiesIds);
    this.changeLegacyCommunities(e);


  }

  changeLastMonth(e: MatSelectChange): void {

    this.nbLastMonth = e.value;
    this.refresh();

  }


  connectAs(userId, action): void {

    this.store.dispatch(ConnectAs({action, userId}));

  }

  loginAs(userJwt, type: 'client' | 'contributor'): void {

    let url = '';
    if (type === 'contributor') {
      url = this.usersListService.generateLoginAsUrl(userJwt);
    } else {
      url = `${window.location.origin}${this.router.createUrlTree(['/log-in', userJwt]).toString()}`;
    }

    window.open(url, '_blank');


  }

  generateLoginAsUrl(userJwt): string {

    const params = [];
    if (this.selectedPublication) {
      params.push(
        {
          key: 'pubUuid', value: this.selectedPublication.selectedItem.uuid
        }
      );
    }
    if (this.modeTestSelected.value === true) {
      params.push(
        {
          key: 'debug', value: '123'
        }
      );
    }

    return this.usersListService.generateLoginAsUrl(userJwt, params, null, true);
  }


  // saasConnectAs(userId): void {
  //   this._store.dispatch(new ConnectAs({ action: 'saasConnectAs', userId }));
  // }

  closeSideNav(): void {
    this.store.dispatch(SetSideNavStatus({opened: false}));
  }

  editUser(userId): void {
    this.store.dispatch(DisplayUserDetail({userId}));
  }


  //
  //
  //
  publicationChanged(e) {
    this.selectedPublication = e;
  }

  // --------------------------------------------------------------------------------------------------------------
  //
  //
  // Edition des ext profils
  //
  ///
  //
  extProfilsSelectionChanged(list): void {

    // console.log('extProfilsSelectionChanged');
    this.selectedExtProfils = [...list];
    this.updateExtProfilForms();

  }

  updateExtProfilForms(doNotUpdateNForm = false) {

    const prevValues = this.fEditExt.getRawValue();

    //
    // On met à jour le dynaForm d'edition
    //
    this.fEditExt = new UntypedFormGroup({});

    this.allExtProfils = [...this.selectedExtProfils, ...this.newExtProfils];

    this.allExtProfils.forEach((anExt) => {
      this.fEditExt.addControl(anExt, new UntypedFormControl());
    });
    // this.newExtProfils.forEach((anExt, index) => {
    //   this.fEditExt.addControl(this.fNEditExt.get([index]).value, new FormControl(`New${index}`));
    // });
    this.newExtProfils.forEach((anExt) => {
      this.fNEditExt.addControl(anExt, new UntypedFormControl(anExt));
    });
    //
    //
    this.fEditExt.patchValue(prevValues, {emitEvent: false});

    //
    // Subscribe des forms
    //
    this.fEditExt.valueChanges.pipe(untilComponentDestroyed(this)).subscribe(() => {
      // console.log('1111111 this.fEditExt.valueChanges!!');
      this.gatherUpdates();
    });

    this.fNEditExt.valueChanges.pipe(
      debounceTime(1500),
      untilComponentDestroyed(this)
    ).subscribe(() => {
      // console.log('222222 this.fNEditExt.valueChanges!!');
      this.slugNewKeys();
      this.gatherUpdates();
    });


  }

  changeLegacyCommunities(e) {

    const projectAndComIdsOnly = e.communities.map((aCommunity: ICommunity) => {
      return {
        projectId: aCommunity.projectId,
        communityId: aCommunity.communityId,
      };
    });

    this.createLegacyEmailGroup.get(['communityId']).patchValue(projectAndComIdsOnly, {emitEvent: false});

  }

  slugNewKeys() {

    const values = this.fNEditExt.getRawValue();

    Object.keys(values).forEach((aValue) => {
      values[aValue] = this.commonServices.getSlug(values[aValue]);
    });

    this.fNEditExt.patchValue(values, {emitEvent: false});

  }

  displayExtSelector(): void {

    this.store.dispatch(displayExtAction());

  }

  openCreateUserDialog(): void {
    this.store.dispatch(OpenCreateUserDialog());
  }

  selectUsersId(e) {
    this.selectedUsersId = e.selectedRowsData.map((filter) => filter.userId);
    if (e.selectedRowsData.length > 0) {
      this.collectUsersInfo();
    }
  }

  markExtAsDelete(index) {

    this.toDeleteExtProfils = cloneDeep(this.toDeleteExtProfils);

    if (this.toDeleteExtProfils.includes(this.selectedExtProfils[index])) {

      const i = this.toDeleteExtProfils.indexOf(this.selectedExtProfils[index]);

      if (i > -1) {
        this.toDeleteExtProfils.splice(i, 1);
      }
      this.fEditExt.get([this.selectedExtProfils[index]]).enable();

    } else {
      this.toDeleteExtProfils.push(this.selectedExtProfils[index]);
      this.fEditExt.get([this.selectedExtProfils[index]]).disable();
    }


  }

  collectUsersInfo() {
    //
    // On build la liste des emails
    this.selectedUsersEmails = this.usersList.filter((aUser) => this.selectedUsersId.includes(aUser.userId)).map((aUser) => aUser.email);
    //
    //
    this.possibleValues = {};
    this.selectedExtProfils.forEach((anExt) => {
      this.possibleValues[anExt] = this.usersList.filter((aUser) => this.selectedUsersId.includes(aUser.userId)).map((aUser) => aUser[anExt]);
      this.possibleValues[anExt] = _.compact(this.possibleValues[anExt]);
      this.possibleValues[anExt] = _.uniq(this.possibleValues[anExt]);
    });

    // console.log('this.possibleValues', this.possibleValues);

    //
    //
  }

  gatherUpdates() {
    // const toUpdate: { [key: string]: string } = {};
    this.editExtModified = {};

    // for (const controlsKey in this.fEditExt.controls) {
    Object.keys(this.fEditExt.controls).forEach((aControlKey) => {
      if (
        this.fEditExt.get([aControlKey]).value?.trim()?.length > 0
        || this.newExtProfilsIndex.includes(aControlKey)) {

        if (!this.toDeleteExtProfils.includes(aControlKey)) {
          this.editExtModified[aControlKey] = this.fEditExt.get([aControlKey]).value;
        }
      }
    });

    // console.log('this.editExtModified', this.editExtModified);

    //
    // Nouveau : on les ajoute toujours !
    //
    this.newExtProfilsIndex.forEach((anNewIndex) => {

      const newKey = this.fNEditExt.get([anNewIndex]).value;
      const value = `${this.editExtModified[anNewIndex]}`;

      delete this.editExtModified[anNewIndex];
      this.editExtModified[newKey] = value;

    });

    this.editExtModifiedIndex = Object.keys(this.editExtModified);

    this.cdr.markForCheck();
    // console.log('this.editExtModified', this.editExtModified);

  }

  addAnExt() {
    const newIndex = `${this.datePipe.transform(new Date(), 'yyyyMMdd')}_${this.newExtProfils.length + 1}`;
    this.newExtProfils.push(newIndex);
    this.newExtProfilsIndex.push(newIndex);
    this.updateExtProfilForms();
  }

  removeAnExt(anExt) {

    console.log(anExt);

    let i = this.newExtProfils.indexOf(anExt);
    this.newExtProfils.splice(i, 1);

    i = this.newExtProfilsIndex.indexOf(anExt);
    this.newExtProfilsIndex.splice(i, 1);

    this.updateExtProfilForms();

  }

  updateExts() {

    const message = [];
    if (Object.keys(this.editExtModified).length > 0) {
      message.push(`<br>Modifier les profils suivant pour les ${this.selectedUsersId.length} utilisateurs sélectionnées ?`);
      message.push(`<pre>${this.jsonPipe.transform(this.editExtModified)}</pre>`);
    }
    if (this.toDeleteExtProfils.length > 0) {
      message.push(`<br>Supprimer les profils suivant pour les ${this.selectedUsersId.length} utilisateurs sélectionnées ?`);
      message.push(`<pre>${this.jsonPipe.transform(this.toDeleteExtProfils)}</pre>`);
    }

    if (this.createLegacyEmailGroup.get(['create']).value) {
      message.push(`<br>Et créer un groupe de distribution de courriel :`);
      message.push(`<pre>${this.jsonPipe.transform(this.createLegacyEmailGroup.getRawValue())}</pre>`);
      // message.push(`Vérifiant la règle suivante:${this.newExtProfilsIndex[0]}=${this.editExtModified}`)
    }

    return confirm(
      message.join('<br>'),
      this.translate.instant('Modifier les ExtProfils suivants ?')
    )
      .then((dialogResult) => {
          if (dialogResult) {
            this.store.dispatch(UpdateBatchExt({
              userIds: this.selectedUsersId as string[],
              updateExts: this.editExtModified,
              deleteExt: this.toDeleteExtProfils,
              createLegacyEmailGroup: this.createLegacyEmailGroup.getRawValue(),
            }));
          }
        }
      );

  }

  assignChipValueToText(anExt, aWord) {
    this.fEditExt.get([anExt]).patchValue(aWord);
  }

  ///
  //
  //
  changeMoveToCommunities(e) {
    const projectAndComIdsOnly = e.communities.map((aCommunity: ICommunity) => {
      return {
        projectId: aCommunity.projectId,
        communityId: aCommunity.communityId,
      };
    });

    this.moveToCommunitiesIds = projectAndComIdsOnly;
  }

  moveToComunities() {
    this.store.dispatch(MoveToCommunities({
        userIds: this.selectedUsersId as string[],
        communitiesIds: this.moveToCommunitiesIds
      }
    ));
  }

  //
  //
  ///
  onExporting(e: ExportingEvent) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('User list');
    let fileName = 'Contributor_Users_list_export.xlsx';
    if (this.currentUserType === 'contributor') {
      worksheet.columns = [
        {header: 'User Id', width: 10}, {header: 'Email.', width: 30}, {header: 'Full name', width: 30}, {header: 'Last logged', width: 30},
      ];
      this.usersList.filter(user => user.type === 'contributor').forEach((item: IUserInbe) => {
        worksheet.addRow([item.userId, item.email, item.fullname, item.lastLogged]);
      });
    } else {
      fileName = 'Client_Users_list_export.xlsx';
      worksheet.columns = [
        {header: 'User Id', width: 10}, {header: 'Organization', width: 30}, {header: 'Email.', width: 30}, {header: 'Full name', width: 30}, {header: 'Last logged', width: 30},
      ];
      this.usersList.filter(user => user.type === 'client').forEach((item: IUserInbe) => {
        worksheet.addRow([item.userId, item.organization, item.email, item.fullname, item.lastLogged]);
      });
    }
    workbook.xlsx.writeBuffer()
      .then((buffer: BlobPart) => {
        saveAs(new Blob([buffer], {type: 'application/octet-stream'}),
          fileName);
      });
  }

}


export interface IUserInbe {

  type: 'contributor' | 'client' | 'annotator';
  media: string;
  userId: string;
  email: string;
  fullname: string;
  lastLogged: Date;
  created: Date;

  // Contributors
  firstname: string;
  lastname: string;
  facebookUrl: string;

  // Clients
  organization: string;
  clientSwitched: string;
  isSaas: string;
  saasOrganization: string;

  extProfils: { id: number; user_id: number; key_name: string; key_value: string }[];


}

// extProfils: [{id: 254, user_id: 263, key_name: "internal_gender", key_value: "F"},…]
// [0 … 99]
// 0: {id: 254, user_id: 263, key_name: "internal_gender", key_value: "F"}
// id: 254
// key_name: "internal_gender"
// key_value: "F"
// user_id: 263
